/**
 * Decodes a JWT payload (no signature check — the backend validates that).
 * Used to read display claims (name, preferred_username, IdBu) and `exp`.
 */
export interface JwtClaims {
  exp?: number;
  name?: string;
  preferred_username?: string;
  IdBu?: string;
  [key: string]: unknown;
}

export const decodeJwt = (token: string): JwtClaims | null => {
  try {
    const payload = token.split('.')[1];
    const normalized = payload.replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(decodeURIComponent(escape(window.atob(normalized))));
  } catch {
    return null;
  }
};

/** True if the token is missing/undecodable or past its `exp` (with a skew buffer). */
export const isJwtExpired = (token: string | null, skewSeconds = 0): boolean => {
  if (!token) {
    return true;
  }
  const claims = decodeJwt(token);
  if (!claims?.exp) {
    return true;
  }
  return claims.exp * 1000 <= Date.now() + skewSeconds * 1000;
};
